import {_GiftCards} from "./_GiftCards";

export const WelfareAPI = {
    GiftCards: _GiftCards
}